<template>
  <div>
    <div class="header">
      <div class="container">
        <div class="logo"><img src="../assets/logo.png" /></div>
        <div class="fr">小小微页 · 整个世界</div>
      </div>
    </div>
    <div class="login">
      <div class="container">

        <div data-v-d9eeeda8="" class="l-login">
          <div data-v-d9eeeda8="" class="l-login-types">
            <div data-v-d9eeeda8="" class="l-login-type cursor" >登录</div>
          </div>
          <div data-v-d9eeeda8="" class="l-login-wrap">
            <div style="padding: 10px 30px 0;">
              <el-form style="padding: 0 50px;">
                <el-input v-model="post.username" type="text" placeholder="账号" class="mt-50"></el-input>
                <el-input v-model="post.password" type="password" placeholder="密码" class="mt-20 mb-20"></el-input>
                <el-button type="success" :loading="is_load" class="submit mt-20" @click="submit">登录</el-button>
              </el-form>
            </div>
          </div>
        </div>

        <div class="login_t">
          <h2>发现不一样的世界</h2>
          <p>宣传单页 · 电子画册 · 有型有视</p>
          <div class="qr"><img src="../assets/qr.jpg" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login_admin",
  data(){
    return{
      post : {
        username : '',
        password : ''
      },
      is_load : false,
    }
  },
  mounted:function(){
    try{
      let that = this;
      that.type_change(that.type);
    }catch (e) {
      console.log(e);
    }
  },
  methods:{
    type_change:async function(type){
      let that = this;
      this.type = type;
      if(type == 'qrcode'){
        let res = await that.$_api.login('create_qrcode');
        if (res.errcode == 0){
          that.qrcode = res.url;
          clearInterval(this.timer);
          this.timer = setInterval( async function  (){
            let login = await that.$_api.login('check_qrcode', {token : res.token});
            if (login.errcode == 0){
              clearInterval(that.timer);
              that.$_showToast(login.errmsg);
              that.$_vueVuex('user',login.user);
              that.$router.replace('/index_user');
            }
          },2000);
        }
      }else{
        clearInterval(this.timer);
      }
    },
    submit:async function (){
      try {
        let post = this.post;
        if (!post.username || !post.password){
          this.$message({
            message : '请填写账号/密码',
            type : 'warning'
          })
          return ;
        }
        this.$_showLoading();
        let res = await this.$_api.login('login',post);
        if (res.errcode == 0) {
          this.$_hideLoading();
          this.$_showToast(res.errmsg);
          this.$_vueVuex('user',res.user);
          this.$_vueVuex('is_login',true);
          this.$router.replace('/index');
        }else{
          this.$_hideLoading();
          this.$_showToast(res.errmsg);
        }
      }catch (e){
        console.log(e);
        return false;
      }
    }
  }
}
</script>

<style scoped>
.submit{
  width: 100%;
  margin: 30px auto;
  background: #32c996;
  font-size: 18px;
}
.qrcode{
  width: 200px;
  height: 200px;
  margin: 40px auto 30px;
  box-shadow: #ccc 0 0 5px 1px;
  border-radius: 5px;
}
.qrcode img{
  width: 100%;
  border-radius: 5px;
}
.cursor{
  /*background: #32c996;*/
  /*color: #fff;*/
  /*border: 1px solid #67C23A;*/
  padding: 10px 0 0 20px;
  font-size: 18px;
  cursor: pointer;
}
.l-login-qrcode,.l-login-tip{
  text-align: center;
}
.l-login-qrcode img{
  display: inline-block;
  width: 200px;
  height: 200px;
  margin-top: 50px;
  margin-bottom: 20px;
}
.container {
  width: 85%;
  min-width: 1200px;
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
}
.header {
  position: relative;
  box-sizing: border-box;background: #fff;box-shadow: 0 4px 10px rgba(0, 0, 0, .1);
  width: 100%;
  height: 90px;
}
.header .logo {
  padding: 15px 0;
  float: left;
}
.header .fr{
  font-size: 22px;
  float: right;
  line-height: 90px;
}
.login{
  background: #32c996 url(../assets/logo_bg.png) no-repeat center bottom;
  min-height: 500px;
  padding:110px 0 50px;
  position: relative;
}
.login .login_t{
  color: #fff;
}
.login .login_t h2{
  font-size: 52px;
  margin: 0;
  padding-bottom: 10px;
}
.login .login_t p{
  font-size: 26px;
  margin: 0;
}
.login .login_t .qr{
  float: left;
  border-radius: 50%;
  margin-top: 50px;
  overflow: hidden;
  background: #fff;
}
.l-login{
  position: absolute;
  top: 20px;
  right: 0;
  width: 500px;
  height: 400px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}
</style>